import Api from './Api';
import { API_ROUTES } from './ApiRoutes';

export const adminCourseAPI = {
    listAllChapters: (courseId?: string, queryParams?: object) =>
        Api.call('GET', API_ROUTES.COURSES.listAllChapters(courseId, queryParams)),
    listAllLessons: (courseId: string, chapterId: string, queryParams?: object) =>
        Api.call('GET', API_ROUTES.COURSES.listAllLessons(courseId, chapterId, queryParams)),
    updateLessonById: (source: string, lessonId: string, payload: any) =>
        Api.call('PATCH', API_ROUTES.COURSES.updateLessonById(source, lessonId), payload),
    getCourseLessonById: (lessonId: string) => Api.call('GET', API_ROUTES.COURSES.getCourseLessonById(lessonId)),
    reorderData: (source: string, payload: any) =>
        Api.call('PATCH', API_ROUTES.COURSES.reorderContent(source), payload),
    addChapter: (payload: { courseId: string; title: string; menuIndex: number }) =>
        Api.call('POST', API_ROUTES.COURSES.addChapter(), payload),
    updateChapter: (chapterId: string, payload: { title: string; menuIndex: number }) =>
        Api.call('PUT', API_ROUTES.COURSES.updateChapter(chapterId), payload),
    deleteChapter: (chapterId: string) => Api.call('DELETE', API_ROUTES.COURSES.deleteChapter(chapterId)),
    addLesson: (payload: { chapterId: string; title: string; menuIndex: number }) =>
        Api.call('POST', API_ROUTES.COURSES.addLesson(), payload),
    deleteLesson: (lessonId: string) => Api.call('DELETE', API_ROUTES.COURSES.deleteLesson(lessonId)),
};

export const adminCreationLibraryAPI = {
    createPromptLibrary: (payload: any) => Api.call('POST', API_ROUTES.CREATION_LIBRARY.createPromptLibrary(), payload),
    listAllPromptLibrary: (queryParams?: object) =>
        Api.call('GET', API_ROUTES.CREATION_LIBRARY.listAllPromptLibrary(queryParams)),
    getPromptById: (promptId: string) => Api.call('GET', API_ROUTES.CREATION_LIBRARY.getPromptById(promptId)),
    deletePrompt: (promptId: string) => Api.call('DELETE', API_ROUTES.CREATION_LIBRARY.deletePrompt(promptId)),
    createConversation: (payload: { conversationType: string; generateLessonIds: string[] }) =>
        Api.call('POST', API_ROUTES.CREATION_LIBRARY.createConversation(), payload),
    validateAttachLessons: (payload: { attachOutlineLessons: string[] }) =>
        Api.call('POST', API_ROUTES.CREATION_LIBRARY.validateAttachLessons(), payload),
    sendConversationMessage: function <IStreamingMessage>(
        payload: any,
        onMessage: (message: IStreamingMessage) => void,
        onError?: (error: any) => void,
    ) {
        return Api.callStream(
            'POST',
            API_ROUTES.CREATION_LIBRARY.sendConversationMessage(),
            payload,
            null,
            onMessage,
            onError,
        );
    },
    editPrompt: (promptId: string, payload: { name: string; prompt: string; promptUsed: boolean }) =>
        Api.call('PUT', API_ROUTES.CREATION_LIBRARY.editPrompt(promptId), payload),
    onCreateConversation: (payload: any) =>
        Api.call('POST', API_ROUTES.CREATION_LIBRARY.onCreateConversation(), payload),
    onUpdateConversation: (conversationId: string, payload: any) =>
        Api.call('PUT', API_ROUTES.CREATION_LIBRARY.onUpdateConversation(conversationId), payload),
};

export const adminAnalyticsAPI = {
    getReportList: (queryParams: string) => Api.call('GET', API_ROUTES.ANALYTICS.getReportList(queryParams)),
    getUserAcquisitionReport: (queryParams?: string) =>
        Api.call('GET', API_ROUTES.ANALYTICS.getUserAcquisitionReport(queryParams)),
    getUserAcquisitionChartReport: (payload: any) =>
        Api.call('POST', API_ROUTES.ANALYTICS.getUserAcquisitionChartReport(), payload),
};

export const adminCoreCreationAPI = {
    listAllCoreChapter: (coreCourseId?: string, queryParams?: object) =>
        Api.call('GET', API_ROUTES.CORE_CREATION.listAllCoreChapter(coreCourseId, queryParams)),
    getCoreCourseLessonById: (coreCourseId: string, chapterId: string, queryParams?: object) =>
        Api.call('GET', API_ROUTES.CORE_CREATION.getCoreCourseLessonById(coreCourseId, chapterId, queryParams)),
};

export const adminOrderReportingAPI = {
    downloadReport: (reportId: string) => Api.call('GET', API_ROUTES.ORDER_REPORTING.downloadReport(reportId)),
    deleteReport: (reportId: string) => Api.call('DELETE', API_ROUTES.ORDER_REPORTING.deleteReport(reportId)),
};

export const studentEventTrackingAPI = {
    metaTrackEvent: (payload: any) => Api.call('POST', API_ROUTES.EVENT_TRACKING.metaTrackEvent(), payload),
};

export const broadcastAPI = {
    getBroadcastUserCount: async (mailingLists: string, categoryId: string, payload: any) =>
        await Api.call('POST', API_ROUTES.BROADCAST.getBroadcastUserCount(mailingLists, categoryId), {
            blockingCondition: payload.blockingCondition,
            blockingItems: payload.blockingItems,
        }),
    createBroadcast: async (payload: any) => await Api.call('POST', API_ROUTES.BROADCAST.createBroadcast(), payload),
    updateBroadcast: async (broadcastId: string, payload: any) =>
        await Api.call('PUT', API_ROUTES.BROADCAST.updateBroadcast(broadcastId), payload),
};

export const adminUserAPI = {
    getAdminUser: (userID: string) => Api.call('GET', API_ROUTES.ADMIN_USER.getAdminUser(userID)),
};

export const adminSettingsAPI = {
    getPresets: () => Api.call('GET', API_ROUTES.ADMINSETTINGS.getPresets()),
    getSelectedPresetDetails: (id: string) => Api.call('GET', API_ROUTES.ADMINSETTINGS.getSelectedPresetDetails(id)),
    updateStateTaxCode: (id: string, payload: { presetStateId: string; taxClass: string }, queryParams?: any) =>
        Api.call('PUT', API_ROUTES.ADMINSETTINGS.updateStateTaxCode(id, queryParams), payload),
    deletePreset: (id: string, queryParams?: any) =>
        Api.call('DELETE', API_ROUTES.ADMINSETTINGS.deletePreset(id, queryParams)),
    createTaxPresets: (payload: { presetName: string }) =>
        Api.call('POST', API_ROUTES.ADMINSETTINGS.createTaxPresets(), payload),
    getTermsOfService: () => Api.call('GET', API_ROUTES.ADMINSETTINGS.getTermsOfService()),
    getPrivacyPolicy: () => Api.call('GET', API_ROUTES.ADMINSETTINGS.getPrivacyPolicy()),
};

export const adminPackagesAPI = {
    updateStateTaxCode: (packageId: string, payload: { presetStateId: string; taxClass: string }) =>
        Api.call('PUT', API_ROUTES.PACKAGES.updateStateTaxCode(packageId), payload),
    applyPreset: (packageId: string, payload: { settingTaxPresetId: string; isSynced: boolean; presetName: string }) =>
        Api.call('PUT', API_ROUTES.PACKAGES.applyPreset(packageId), payload),
};

export const CheckoutAPI = {
    validateAddress: (payload: any) => Api.call('POST', API_ROUTES.CHECKOUT.validateAddress(), payload),
};
